<template>
    <div class="col-12 fetchedText">
        <div class="table-fluid">
            <ul class="search-table">
                <template v-if="hasNorskOrdbank('nob')">
                    <li class="col-12 padding">
                        <dl class="row">
                            <dt
                                class="col-lg-3 col-sm-4 col-6 bold-text"
                                v-bind:class="[isPictureView ? 'backgrd':'' ]"
                            >
                                <span class="dynamic">{{ $t('message.bokmal') }}</span>
                                <span
                                    v-bind:class="[isPictureView ? 'nor-text-picture bold ':'nor-text-new' ]"
                                >{{ $t('message.lemma') }}</span>
                            </dt>

                            <dd
                                class="col-6 col-lg-9 col-sm-8 nor-text clsE"
                                data-type="LEM"
                                :lang="getLanguageIsoCode()"
                            >
                                <NorskOrdbankResultPronunciation
                                    :norskOrdbank="getNorskOrdbank('nob')"
                                    :lemValue="getOrdbankLemValue('nob')"
                                    :searchWord="getSearchWord()"
                                />
                            </dd>
                        </dl>
                    </li>
                </template>
                <template v-else>
                    <li class="col-12 padding" v-if="eLem">
                        <dl class="row">
                            <dt
                                class="col-lg-3 col-sm-4 col-6 bold-text"
                                v-bind:class="[isPictureView ? 'backgrd':'' ]"
                            >
                                <span class="dynamic">{{ $t('message.bokmal') }}</span>
                                <span
                                    v-bind:class="[isPictureView ? 'nor-text-picture bold ':'nor-text-new' ]"
                                >{{ $t('message.lemma') }}</span>
                            </dt>

                            <dd
                                class="col-6 col-lg-9 col-sm-8 nor-text clsE"
                                data-type="LEM"
                                :lang="languageCodeList.find(x=>x.lang==eLem.lang).langISOCode"
                            >
                                <b v-html="eLem.text" ref="link1"></b>&nbsp;
                                <a class="tts-btn" tabindex="0" role="button" href="javascript:void(0)" onclick="javascript:tts(this);"
                                   :aria-label="$t('message.play-tts')">
                                    <img class="pointer speaker-image" :alt="$t('message.speech-synthesis_icon')"
                                         src="/images/speaker-small.svg">
                                </a>
                            </dd>
                        </dl>
                    </li>
                    <li class="col-12 padding" v-if="nLem && eLem===undefined">
                        <dl class="row">
                            <dt
                                class="col-6 col-lg-3 col-sm-4 bold-text"
                                v-bind:class="[isPictureView ? 'backgrd':'' ]"
                            >
                                <span class="dynamic">{{ $t('message.bokmal') }}</span>
                                <span
                                    v-bind:class="[isPictureView ? 'nor-text-picture bold':'nor-text-new' ]"
                                >{{ $t('message.lemma') }}</span>
                            </dt>
                            <dd
                                class="col-6 col-lg-9 col-sm-8 nor-text clsE"
                                data-type="LEM"
                                :lang="languageCodeList.find(x=>x.lang==nLem.lang).langISOCode"
                            >
                                <b v-html="nLem.text" ref="link3"></b>&nbsp;
                                <a class="tts-btn" tabindex="0" role="button" href="javascript:void(0)" onclick="javascript:tts(this);"
                                   :aria-label="$t('message.play-tts')">
                                    <img class="pointer speaker-image" :alt="$t('message.speech-synthesis_icon')"
                                         src="/images/speaker-small.svg">
                                </a>
                            </dd>
                        </dl>
                    </li>
                </template>
                <template v-if="!hasNorskOrdbank('nob')">
                    <li class="col-12 padding" v-if="eUtt">
                        <dl class="row">
                            <dt class="col-6 col-lg-3 col-sm-4 bold-text"></dt>
                            <dd
                                class="col-6 col-lg-9 col-sm-8 nor-text utt-text"
                                data-type="UTT"
                                :lang="languageCodeList.find(x=>x.lang==eUtt.lang).langISOCode"
                            >
                                <Pronunciation v-if="eUtt || false" :value="eUtt.text" />
                            </dd>
                        </dl>
                    </li>
                    <li class="col-12 padding" v-if="nUtt && eUtt===undefined">
                        <dl class="row">
                            <dt class="col-6 col-lg-3 col-sm-4 bold-text"></dt>
                            <dd
                                class="col-6 col-lg-9 col-sm-8 nor-text utt-text"
                                data-type="UTT"
                                :lang="languageCodeList.find(x=>x.lang==nUtt.lang).langISOCode"
                            >
                                <Pronunciation v-if="nUtt || false" :value="nUtt.text" />
                            </dd>
                        </dl>
                    </li>
                </template>
                <li class="col-12 padding" v-if="bLem">
                    <dl class="row">
                        <dt
                            class="col-lg-3 col-sm-4 col-6 bold-text"
                            v-bind:class="[isPictureView ? 'backgrd':'' ]"
                        >
                            <span class="dynamic">{{ $t('message.english') }}</span>
                            <span
                                v-if="eLem === undefined && nLem ===undefined"
                                v-bind:class="[isPictureView ? 'nor-text-picture bold ':'nor-text-new' ]"
                            >{{ $t('message.lemma') }}</span>
                        </dt>
                        <dd
                            class="col-lg-9 col-sm-8 col-6 nor-text"
                            data-type="LEM"
                            :lang="languageCodeList.find(x=>x.lang=='B').langISOCode"
                        >
                            <b v-html="bLem.text" ref="link5"></b>
                        </dd>
                    </dl>
                </li>
                <template v-if="lastLem">
                    <template v-if="hasNorskOrdbank('nno')">
                        <li class="col-12" v-if="lastLem.text">
                            <dl class="row">
                                <dt
                                    class="col-lg-3 col-sm-4 col-6 bold-text"
                                    v-bind:class="[isPictureView ? 'backgrd':'' ]"
                                    style="text-transform: capitalize;"
                                >
                                    <span class="dynamic">{{ secondLang }}</span>
                                    <span
                                        v-if="eLem === undefined && nLem ===undefined && bLem=== undefined"
                                        v-bind:class="[isPictureView ? 'nor-text-picture bold ':'nor-text-new' ]"
                                    >{{ $t('message.lemma') }}</span>
                                </dt>
                                <dd
                                    class="col-lg-9 col-sm-8 col-6 font-thin"
                                    data-type="LEM"
                                    :lang="languageCodeList.find(x=>x.lang==lastLem.lang).langISOCode"
                                    v-bind:class="[isLeftAllign ? 'urd-text' : 'nor-text']"
                                >
                                    <NorskOrdbankResultPronunciation
                                        :norskOrdbank="getNorskOrdbank('nno')"
                                        :lemValue="getOrdbankLemValue('nno')"
                                        :searchWord="getSearchWord()"
                                    />
                                </dd>
                            </dl>
                        </li>
                    </template>
                    <template
                        v-else-if="lastLem.text.includes('&&')"
                        v-for="(nnylem,index) in lastLem.text.split('&&').filter(x=>x.match('[^ -]')).reverse()"
                    >
                        <li class="col-12" v-if="nnylem">
                            <dl class="row">
                                <dt
                                    class="col-lg-3 col-sm-4 col-6 bold-text"
                                    v-bind:class="[isPictureView ? 'backgrd':'' ]"
                                    style="text-transform: capitalize;"
                                >
                                    <span v-if="index===0 || isPictureView" class="dynamic">{{ secondLang }}</span>
                                    <span
                                        v-if="eLem === undefined && nLem ===undefined && bLem=== undefined"
                                        v-bind:class="[isPictureView ? 'nor-text-picture bold ':'nor-text-new' ]"
                                    >{{ $t('message.lemma') }}</span>
                                </dt>
                                <dd
                                    class="col-lg-9 col-sm-8 col-6 font-thin"
                                    data-type="LEM"
                                    :lang="languageCodeList.find(x=>x.lang==lastLem.lang).langISOCode"
                                    v-bind:class="[isLeftAllign ? 'urd-text' : 'nor-text']"
                                >
                                    <b v-html="nnylem" ref="link7"></b>
                                    <a v-if="lastLem.lang === 'NNY'" class="tts-btn" tabindex="0" href="javascript:void(0)"
                                       role="button" onclick="javascript:tts(this);"
                                       :aria-label="$t('message.play-tts')">
                                        <img
                                            class="pointer speaker-image"
                                            :alt="$t('message.speech-synthesis_icon')" src="/images/speaker-small.svg">
                                    </a>
                                </dd>
                            </dl>
                        </li>
                            <li class="col-12" v-if="lastUtt && !hasNorskOrdbank('nno')">
                                <dl
                                    class="row"
                                    v-if="lastUtt.text.split('&&').filter(x=>x.match('[^ -]')).reverse()[index]"
                                >
                                    <dt class="col-lg-3 col-sm-4 col-6 bold-text"></dt>
                                    <dd
                                        class="col-lg-9 col-sm-8 col-6 nor-text utt-text"
                                        data-type="UTT"
                                        :lang="languageCodeList.find(x=>x.lang==lastUtt.lang).langISOCode"
                                    >
                                        <Pronunciation v-if="lastUtt || false" :value="lastUtt.text.split('&&').filter(x=>x.match('[^ -]')).reverse()[index]" />
                                    </dd>
                                </dl>
                            </li>
                        <li class="col-12" v-if="lastkat">
                            <dl
                                class="row"
                                v-if="lastkat.text.split('&&').filter(x=>x.match('[^ -]')).reverse()[index]"
                            >
                                <dt class="col-lg-3 col-sm-4 col-6 bold-text"></dt>
                                <dd
                                    class="col-lg-9 col-sm-8 col-6 font-thin"
                                    data-type="KAT"
                                    :lang="languageCodeList.find(x=>x.lang==lastkat.lang).langISOCode"
                                    v-bind:class="[isLeftAllign ? 'urd-text' : 'nor-text']"
                                >
                                    <PartOfSpeachHeader
                                        v-if="hasTextProperty(lastLem)"
                                        :snId="getSnId()"
                                        :lemInfo="lastLem"
                                        :katInfo="lastKat"
                                        :partOfSpeachInfo="partOfSpeachInfo"
                                    />

                                    <a v-if="lastkat.lang === 'NNY'" class="tts-btn" tabindex="0" href="javascript:void(0)"
                                       role="button" onclick="javascript:tts(this);"
                                       :aria-label="$t('message.play-tts')">
                                        <img
                                            class="pointer speaker-image"
                                            :alt="$t('message.speech-synthesis_icon')" src="/images/speaker-small.svg">
                                    </a>
                                </dd>
                            </dl>
                        </li>
                    </template>
                    <template v-else>
                        <template v-if="hasNorskOrdbank('nno') && lastLem">
                            <li class="col-12" v-if="lastLem">
                                <dl class="row">
                                    <dt
                                        class="col-lg-3 col-sm-4 col-6 bold-text"
                                        v-bind:class="[isPictureView ? 'backgrd':'' ]"
                                        style="text-transform: capitalize;"
                                    >
                                        <span class="dynamic">{{ secondLang }}</span>
                                        <span
                                            v-if="eLem === undefined && nLem ===undefined && bLem=== undefined"
                                            v-bind:class="[isPictureView ? 'nor-text-picture bold ':'nor-text-new' ]"
                                        >{{ $t('message.lemma') }}</span>
                                    </dt>
                                    <dd
                                        data-type="LEM"
                                        :lang="getLanguageIsoCode()"
                                        class="col-lg-9 col-sm-8 col-6 font-thin"
                                        v-bind:class="[isLeftAllign ? 'urd-text' : 'nor-text']"
                                    >
                                        <NorskOrdbankResultPronunciation
                                            :norskOrdbank="getNorskOrdbank('nno')"
                                            :lemValue="getOrdbankLemValue('nno')"
                                            :searchWord="getSearchWord()"
                                        />
                                    </dd>
                                </dl>
                            </li>
                        </template>
                        <template v-else>
                            <li class="col-12" v-if="lastLem">
                                <dl class="row">
                                    <dt
                                        class="col-lg-3 col-sm-4 col-6 bold-text"
                                        v-bind:class="[isPictureView ? 'backgrd':'' ]"
                                        style="text-transform: capitalize;"
                                    >
                                        <span class="dynamic">{{ secondLang }}</span>
                                        <span
                                            v-if="eLem === undefined && nLem ===undefined && bLem=== undefined"
                                            v-bind:class="[isPictureView ? 'nor-text-picture bold ':'nor-text-new' ]"
                                        >{{ $t('message.lemma') }}</span>
                                    </dt>
                                    <dd
                                        data-type="LEM"
                                        :lang="languageCodeList.find(x=>x.lang==lastLem.lang).langISOCode"
                                        class="col-lg-9 col-sm-8 col-6 font-thin"
                                        v-bind:class="[isLeftAllign ? 'urd-text' : 'nor-text']"
                                    >
                                        <b v-html="lastLem.text" ref="link7"></b>&nbsp;
                                        <a v-if="lastLem.lang === 'NNY'" class="tts-btn" tabindex="0" href="javascript:void(0)"
                                           role="button" onclick="javascript:tts(this);"
                                           :aria-label="$t('message.play-tts')">
                                            <img
                                                class="pointer speaker-image"
                                                :alt="$t('message.speech-synthesis_icon')" src="/images/speaker-small.svg"
                                            >
                                        </a>
                                    </dd>
                                </dl>
                            </li>
                        </template>
                        <template v-if="!(hasNorskOrdbank('nno') && lastUtt && lastLem)">
                            <li class="col-12" v-if="lastUtt && lastLem">
                                <dl class="row">
                                    <dt class="col-lg-3 col-sm-4 col-6 bold-text"></dt>
                                    <dd
                                        class="col-lg-9 col-sm-8 col-6 nor-text utt-text"
                                        data-type="UTT"
                                        :lang="languageCodeList.find(x=>x.lang==lastUtt.lang).langISOCode"
                                    >
                                        <Pronunciation v-if="lastUtt || false" :value="lastUtt.text" />
                                    </dd>
                                </dl>
                            </li>
                        </template>
                    </template>
                </template>
                <li class="ordbank-boyning" v-if="hasLanguageContent(eLem || nLem)" lang="nb">
                    <hr />
                    <NorskOrdbankResultBlocks
                        :snId="getSnId()"
                        :initialBlockInfo="getOrdbankInitialBlockInfo('nob')"
                        :showLiContent="true"
                        :defaultOpen="getDefaultOrdbankOpen(eLem, nLem, lastLem)"
                    />
                </li>
                <li class="col-12 padding" v-if="bKat">
                    <dl class="row">
                        <dt class="col-lg-3 col-sm-4 col-6 bold-text">{{ $t('message.english') }}</dt>
                        <dd
                            class="col-lg-9 col-sm-8 col-6 nor-text"
                            data-type="KAT"
                            :lang="languageCodeList.find(x=>x.lang=='B').langISOCode"
                            ref="link6"
                        >
                            <PartOfSpeachHeader
                                v-if="hasTextProperty(bKat)"
                                :snId="getSnId()"
                                :lemInfo="bLem"
                                :katInfo="bKat"
                                :partOfSpeachInfo="partOfSpeachInfo"
                            />
                        </dd>
                    </dl>
                </li>
                <li class="ordbank-boyning" :lang="getLangAttribute('last')" v-if="showLastOrdbank()">
                    <NorskOrdbankResultBlocks
                        :snId="getSnId()"
                        :initialBlockInfo="getOrdbankInitialBlockInfo('last')"
                        :showLiContent="true"
                        :showInflectionHeader="false"
                        :defaultOpen="getDefaultOrdbankOpen(eLem, nLem, lastLem)"
                        :secondLang="secondLang"
                    />
                </li>
                <template v-if="!hasNorskOrdbank('nob')">
                    <li class="col-12 padding" v-if="eAlt">
                        <dl class="row">
                            <dt class="col-lg-3 col-sm-4 col-6 bold-text">
                                <span class="dynamic">{{ $t('message.bokmal') }}</span>
                                <span
                                    class="reg-text"
                                    v-bind:class="[isPictureView ? 'nor-text-picture bold':'nor-text-new' ]"
                                >{{ $t('message.alternative') }}</span>
                            </dt>
                            <dd
                                class="col-lg-9 col-sm-8 col-6 nor-text clsE"
                                data-type="ALT"
                                :lang="languageCodeList.find(x=>x.lang==eAlt.lang).langISOCode"
                            >
                                <span v-html="eAlt.text" ref="link9"></span>
                                <a class="tts-btn" tabindex="0" role="button" href="javascript:void(0)" onclick="javascript:tts(this);"
                                   :aria-label="$t('message.play-tts')">
                                    <img class="pointer speaker-image" :alt="$t('message.speech-synthesis_icon')"
                                         src="/images/speaker-small.svg">
                                </a>
                            </dd>
                        </dl>
                    </li>
                    <li class="col-12 padding" v-if="nAlt && eAlt===undefined">
                        <dl class="row">
                            <dt class="col-lg-3 col-sm-4 col-6 bold-text">
                                <span class="dynamic">{{ $t('message.bokmal') }}</span>
                                <span
                                    class="reg-text"
                                    v-bind:class="[isPictureView ? 'nor-text-picture bold':'nor-text-new' ]"
                                >{{ $t('message.alternative') }}</span>
                            </dt>
                            <dd
                                class="col-lg-9 col-sm-8 col-6 nor-text clsE"
                                data-type="ALT"
                                :lang="languageCodeList.find(x=>x.lang==nAlt.lang).langISOCode"
                            >
                                <span v-html="nAlt.text" ref="link10"></span>
                                <a class="tts-btn" tabindex="0" role="button" href="javascript:void(0)" onclick="javascript:tts(this);"
                                   :aria-label="$t('message.play-tts')">
                                    <img class="pointer speaker-image" :alt="$t('message.speech-synthesis_icon')"
                                         src="/images/speaker-small.svg">
                                </a>
                            </dd>
                        </dl>
                    </li>
                </template>
                <li class="col-12 padding" v-if="bAlt">
                    <dl class="row">
                        <dt class="col-lg-3 col-sm-4 col-6 bold-text">
                            <span class="dynamic">{{ $t('message.english') }}</span>
                            <span
                                v-if="nAlt ===undefined && eAlt===undefined"
                                class="reg-text"
                                v-bind:class="[isPictureView ? 'nor-text-picture bold':'nor-text-new' ]"
                            >{{ $t('message.alternative') }}</span>
                        </dt>
                        <dd
                            class="col-lg-9 col-sm-8 col-6 nor-text clsE"
                            data-type="ALT"
                            :lang="languageCodeList.find(x=>x.lang=='B').langISOCode"
                            v-html="bAlt.text"
                            ref="link11"
                        >
                            <a class="tts-btn" tabindex="0" role="button" href="javascript:void(0)" onclick="javascript:tts(this);"
                               :aria-label="$t('message.play-tts')">
                                <img class="pointer speaker-image" :alt="$t('message.speech-synthesis_icon')"
                                     src="/images/speaker-small.svg">
                            </a>
                        </dd>
                    </dl>
                </li>
                <template v-if="!hasNorskOrdbank('nno')">
                    <li class="col-12 padding" v-if="lastAlt" v-for="(alts,index) in lastAlt" :key="alts+'-'+index">
                        <template v-if="alts.lang=='NNY'&& alts.text.includes('&&')">
                            <dl
                                class="row"
                                v-for="(alt,index1) in alts.text.split('&&').filter(x=>x.match('[^ -]' && x.length !=0)).reverse()"
                                :key="alt+'-'+index"
                            >
                                <dt v-if="index1===0" class="col-lg-3 col-sm-4 col-6 bold-text">
                                    <span class="dynamic">{{ secondLang }}</span>
                                    <span
                                        v-if="nAlt ===undefined && eAlt===undefined && bKat===undefined && index1===0"
                                        class="reg-text"
                                        v-bind:class="[isPictureView ? 'nor-text-picture bold':'nor-text-new' ]"
                                    >{{ $t('message.alternative') }}</span>
                                </dt>
                                <dd
                                    class="col-lg-9 col-sm-8 col-6 clsE"
                                    v-bind:class="[isLeftAllign ? 'urd-text' : 'nor-text']"
                                    data-type="ALT"
                                    :lang="languageCodeList.find(x=>x.lang==alts.lang).langISOCode"
                                >
                                    <span v-html="alt" ref="link12"></span>
                                    <a v-if="alts.lang === 'NNY'" class="tts-btn" tabindex="0" href="javascript:void(0)" role="button"
                                       onclick="javascript:tts(this);" :aria-label="$t('message.play-tts')">
                                        <img
                                            class="pointer speaker-image"
                                            :alt="$t('message.speech-synthesis_icon')" src="/images/speaker-small.svg"
                                        >
                                    </a>
                                </dd>
                            </dl>
                        </template>
                        <template v-else>
                            <dl class="row">
                                <dt class="col-lg-3 col-sm-4 col-6 bold-text">
                                    <span class="dynamic">{{ secondLang }}</span>
                                    <span
                                        v-if="nAlt ===undefined && eAlt===undefined && bKat===undefined"
                                        class="reg-text"
                                        v-bind:class="[isPictureView ? 'nor-text-picture bold':'nor-text-new' ]"
                                    >{{ $t('message.alternative') }}</span>
                                </dt>
                                <dd
                                    class="col-lg-9 col-sm-8 col-6 clsE"
                                    v-bind:class="[isLeftAllign ? 'urd-text' : 'nor-text']"
                                    data-type="ALT"
                                    :lang="languageCodeList.find(x=>x.lang==alts.lang).langISOCode"
                                >
                                    <span v-html="alts.text" ref="link12"></span>
                                    <a v-if="alts.lang === 'NNY'" class="tts-btn" tabindex="0" href="javascript:void(0)" role="button"
                                       onclick="javascript:tts(this);" :aria-label="$t('message.play-tts')">
                                        <img
                                            class="pointer speaker-image"
                                            :alt="$t('message.speech-synthesis_icon')" src="/images/speaker-small.svg"
                                        >
                                    </a>
                                </dd>
                            </dl>
                        </template>
                    </li>
                </template>
                <li class="col-12 padding" v-if="bMor">
                    <dl class="row">
                        <dt class="col-lg-3 col-sm-4 col-6 bold-text">
                            <span class="dynamic">{{ $t('message.english') }}</span>
                            <span
                                v-if="nMor ===undefined && eMor===undefined"
                                class="reg-text"
                                v-bind:class="[isPictureView ? 'nor-text-picture bold':'nor-text-new' ]"
                            >{{ $t('message.morphology') }}</span>
                        </dt>
                        <dd
                            class="col-lg-9 col-sm-8 col-6 clsE clsE"
                            :data-lemma='bLem'
                            data-type="MOR"
                            :lang="languageCodeList.find(x=>x.lang=='B').langISOCode"
                            v-html="'['+bMor.text+']'"
                            ref="link15"
                        ></dd>
                    </dl>
                </li>
                <li class="col-12 padding" v-if="eKom">
                    <hr />
                    <dl class="row">
                        <dt class="col-lg-3 col-sm-4 col-6 bold-text">
                            <span class="dynamic">{{ $t('message.bokmal') }}</span>
                            <span
                                class="reg-text"
                                v-bind:class="[isPictureView ? 'nor-text-picture bold':'nor-text-new' ]"
                            >{{ $t('message.comment') }}</span>
                        </dt>
                        <dd
                            class="col-lg-9 col-sm-8 col-6 clsE nor-text"
                            data-type="KOM"
                            :lang="languageCodeList.find(x=>x.lang==eKom.lang).langISOCode"
                        >
                            <span v-html="eKom.text" ref="link17"></span>
                            <a class="tts-btn" tabindex="0" role="button" href="javascript:void(0)" onclick="javascript:tts(this);"
                               :aria-label="$t('message.play-tts')">
                                <img class="pointer speaker-image" :alt="$t('message.speech-synthesis_icon')"
                                     src="/images/speaker-small.svg">
                            </a>
                        </dd>
                    </dl>
                </li>
                <li class="col-12 padding" v-if="nKom && eKom===undefined">
                    <hr />
                    <dl class="row">
                        <dt class="col-lg-3 col-sm-4 col-6 bold-text">
                            <span class="dynamic">{{ $t('message.bokmal') }}</span>
                            <span
                                class="reg-text"
                                v-bind:class="[isPictureView ? 'nor-text-picture bold':'nor-text-new' ]"
                            >{{ $t('message.comment') }}</span>
                        </dt>
                        <dd
                            class="col-lg-9 col-sm-8 col-6 clsE nor-text"
                            data-type="KOM"
                            :lang="languageCodeList.find(x=>x.lang==nKom.lang).langISOCode"
                        >
                            <span v-html="nKom.text" ref="link18"></span>
                            <a class="tts-btn" tabindex="0" role="button" href="javascript:void(0)" onclick="javascript:tts(this);"
                               :aria-label="$t('message.play-tts')">
                                <img class="pointer speaker-image" :alt="$t('message.speech-synthesis_icon')"
                                     src="/images/speaker-small.svg">
                            </a>
                        </dd>
                    </dl>
                </li>
                <li class="col-12 padding" v-if="bKom">
                    <dl class="row">
                        <dt class="col-lg-3 col-sm-4 col-6 bold-text">
                            <span class="dynamic">{{ $t('message.english') }}</span>
                            <span
                                v-if="nKom===undefined && eKom===undefined"
                                class="reg-text"
                                v-bind:class="[isPictureView ? 'nor-text-picture bold':'nor-text-new' ]"
                            >{{ $t('message.comment') }}</span>
                        </dt>
                        <dd
                            class="col-lg-9 col-sm-8 col-6 clsE nor-text"
                            data-type="KOM"
                            :lang="languageCodeList.find(x=>x.lang=='B').langISOCode"
                            v-html="bKom.text"
                            ref="link19"
                        ></dd>
                    </dl>
                </li>
                <li class="col-12 padding" v-if="lastKom">
                    <dl
                        class="row"
                        v-if="lastKom.lang=='NNY' && lastKom.text.includes('&&')"
                        v-for="(kom,index1) in lastKom.text.split('&&').filter(x=>x.match('[^ -]') && x.length != 0).reverse()"
                        :key="mor+'-'+index1"
                    >
                        <dt class="col-lg-3 col-sm-4 col-6 bold-text mobile-tab-left">
                            <span v-if="index1===0" class="dynamic">{{ secondLang }}</span>
                            <span
                                v-if="nKom===undefined && eKom===undefined && bKom===undefined && index1===0"
                                class="reg-text"
                                v-bind:class="[isPictureView ? 'nor-text-picture bold':'nor-text-new' ]"
                            >{{ $t('message.comment') }}</span>
                        </dt>
                        <dd
                            class="col-lg-9 col-sm-8 col-6 clsE nor-text"
                            data-type="KOM"
                            :lang="languageCodeList.find(x=>x.lang==lastKom.lang).langISOCode"
                            v-bind:class="[isLeftAllign ? 'urd-text' : 'nor-text']"
                        >
                            <span v-html="kom" ref="link20"></span>
                            <a class="tts-btn" tabindex="0" role="button" href="javascript:void(0)" onclick="javascript:tts(this);"
                               :aria-label="$t('message.play-tts')">
                                <img
                                    v-if="lastKom.lang === 'NNY'"
                                    class="pointer speaker-image"
                                    :alt="$t('message.speech-synthesis_icon')" src="/images/speaker-small.svg"
                                >
                            </a>
                        </dd>
                    </dl>
                    <dl class="row" v-else>
                        <dt class="col-lg-3 col-sm-4 col-6 bold-text">
                            <span class="dynamic">{{ secondLang }}</span>
                            <span
                                v-if="nKom===undefined && eKom===undefined && bKom===undefined"
                                class="reg-text"
                                v-bind:class="[isPictureView ? 'nor-text-picture bold':'nor-text-new' ]"
                            >{{ $t('message.comment') }}</span>
                        </dt>
                        <dd
                            class="col-lg-9 col-sm-8 col-6 clsE nor-fetchedText"
                            data-type="KOM"
                            :lang="languageCodeList.find(x=>x.lang==lastKom.lang).langISOCode"
                            v-bind:class="[isLeftAllign ? 'urd-text' : 'nor-text']"
                        >
                            <span v-html="lastKom.text" ref="link20"></span>
                            <a v-if="lastKom.lang === 'NNY'" class="tts-btn" tabindex="0" href="javascript:void(0)" role="button"
                               onclick="javascript:tts(this);" :aria-label="$t('message.play-tts')">
                                <img
                                    class="pointer speaker-image"
                                    :alt="$t('message.speech-synthesis_icon')" src="/images/speaker-small.svg"
                                >
                            </a>
                        </dd>
                    </dl>
                </li>
                <li class="col-12 padding" v-if="eGrm">
                    <hr />
                    <dl class="row">
                        <dt class="col-lg-3 col-sm-4 col-6 bold-text">
                            <span class="dynamic">{{ $t('message.bokmal') }}</span>
                            <span
                                class="reg-text"
                                v-bind:class="[isPictureView ? 'nor-text-picture bold':'nor-text-new' ]"
                            >{{ $t('message.grammar') }}</span>
                        </dt>
                        <dd
                            class="col-lg-9 col-sm-8 col-6 clsE nor-text"
                            data-type="GRM"
                            :lang="languageCodeList.find(x=>x.lang==eGrm.lang).langISOCode"
                        >
                            <span v-html="eGrm.text" ref="link21"></span>
                            <a class="tts-btn" tabindex="0" role="button" href="javascript:void(0)" onclick="javascript:tts(this);"
                               :aria-label="$t('message.play-tts')">
                                <img class="pointer speaker-image" :alt="$t('message.speech-synthesis_icon')"
                                     src="/images/speaker-small.svg">
                            </a>
                        </dd>
                    </dl>
                </li>
                <li class="col-12 padding" v-if="nGrm && eGrm===undefined">
                    <hr />
                    <dl class="row">
                        <dt class="col-lg-3 col-sm-4 col-6 bold-text">
                            <span class="dynamic">{{ $t('message.bokmal') }}</span>
                            <span
                                class="reg-text"
                                v-bind:class="[isPictureView ? 'nor-text-picture bold':'nor-text-new' ]"
                            >{{ $t('message.grammar') }}</span>
                        </dt>
                        <dd
                            class="col-lg-9 col-sm-8 col-6 clsE nor-text"
                            data-type="GRM"
                            :lang="languageCodeList.find(x=>x.lang==nGrm.lang).langISOCode"
                        >
                            <span v-html="nGrm.text" ref="link22"></span>
                            <a class="tts-btn" tabindex="0" role="button" href="javascript:void(0)" onclick="javascript:tts(this);"
                               :aria-label="$t('message.play-tts')">
                                <img class="pointer speaker-image" :alt="$t('message.speech-synthesis_icon')"
                                     src="/images/speaker-small.svg">
                            </a>
                        </dd>
                    </dl>
                </li>
                <li class="col-12 padding" v-if="bGrm">
                    <dl class="row">
                        <dt class="col-lg-3 col-sm-4 col-6 bold-text">
                            <span class="dynamic">{{ $t('message.english') }}</span>
                            <span
                                v-if="nGrm ===undefined && eGrm===undefined"
                                class="reg-text"
                                v-bind:class="[isPictureView ? 'nor-text-picture bold':'nor-text-new' ]"
                            >{{ $t('message.grammar') }}</span>
                        </dt>
                        <dd
                            class="col-lg-9 col-sm-8 col-6 clsE nor-text"
                            data-type="GRM"
                            :lang="languageCodeList.find(x=>x.lang=='B').langISOCode"
                            v-html="bGrm.text"
                            ref="link23"
                        ></dd>
                    </dl>
                </li>
                <li class="col-12 padding" v-if="lastGrm">
                    <dl
                        class="row"
                        v-if="lastGrm.lang=='NNY' && lastGrm.text.includes('&&')"
                        v-for="(grm,index1) in lastGrm.text.split('&&').filter(x=>x.match('[^ -]')).reverse()"
                        :key="grm+'-'+index1"
                    >
                        <dt class="col-lg-3 col-sm-4 col-6 bold-text">
                            <span v-if="index1===0" class="dynamic">{{ secondLang }}</span>
                            <span
                                v-if="nGrm ===undefined && eGrm===undefined && lastGrm===undefined && index===0"
                                class="reg-text"
                                v-bind:class="[isPictureView ? 'nor-text-picture bold':'nor-text-new' ]"
                            >{{ $t('message.grammar') }}</span>
                        </dt>
                        <dd
                            class="col-lg-9 col-sm-8 col-6 clsE nor-text"
                            v-bind:class="[isLeftAllign ? 'urd-text' : 'nor-text']"
                            data-type="GRM"
                            :lang="languageCodeList.find(x=>x.lang==lastGrm.lang).langISOCode"
                        >
                            <span v-html="grm" ref="link24"></span>
                            <a class="tts-btn" tabindex="0" role="button" href="javascript:void(0)" v-if="lastGrm.lang === 'NNY'"
                               onclick="javascript:tts(this);" :aria-label="$t('message.play-tts')">
                                <img
                                    class="pointer speaker-image"
                                    :alt="$t('message.speech-synthesis_icon')" src="/images/speaker-small.svg"
                                >
                            </a>
                        </dd>
                    </dl>
                    <dl class="row" v-else>
                        <dt class="col-lg-3 col-sm-4 col-6 bold-text">
                            <span class="dynamic">{{ secondLang }}</span>
                            <span
                                v-if="nGrm ===undefined && eGrm===undefined && lastGrm===undefined"
                                class="reg-text"
                                v-bind:class="[isPictureView ? 'nor-text-picture bold':'nor-text-new' ]"
                            >{{ $t('message.grammar') }}</span>
                        </dt>
                        <dd
                            class="col-lg-9 col-sm-8 col-6 clsE nor-text"
                            v-bind:class="[isLeftAllign ? 'urd-text' : 'nor-text']"
                            data-type="GRM"
                            :lang="languageCodeList.find(x=>x.lang==lastGrm.lang).langISOCode"
                        >
                            <span v-html="lastGrm.text" ref="link24"></span>
                            <a class="tts-btn" tabindex="0" role="button" href="javascript:void(0)" v-if="lastGrm.lang === 'NNY'"
                               onclick="javascript:tts(this);" :aria-label="$t('message.play-tts')">
                                <img
                                    class="pointer speaker-image"
                                    :alt="$t('message.speech-synthesis_icon')" src="/images/speaker-small.svg"

                                >
                            </a>
                        </dd>
                    </dl>
                </li>
                <li class="col-12 padding" v-if="eDef">
                    <hr />
                    <dl class="row">
                        <dt class="col-lg-3 col-sm-4 col-6 bold-text">
                            <span class="dynamic">{{ $t('message.bokmal') }}</span>
                            <span
                                class="reg-text"
                                v-bind:class="[isPictureView ? 'nor-text-picture bold':'nor-text-new' ]"
                            >{{ $t('message.explanation') }}</span>
                        </dt>
                        <dd
                            class="col-lg-9 col-sm-8 col-6 nor-text clsN"
                            data-type="DEF"
                            :lang="languageCodeList.find(x=>x.lang==eDef.lang).langISOCode"
                        >
                            <span v-html="eDef.text" ref="link25"></span>
                            <a class="tts-btn" tabindex="0" role="button" href="javascript:void(0)" onclick="javascript:tts(this);"
                               :aria-label="$t('message.play-tts')">
                                <img class="pointer speaker-image" :alt="$t('message.speech-synthesis_icon')"
                                     src="/images/speaker-small.svg">
                            </a>
                        </dd>
                    </dl>
                </li>
                <li class="col-12 padding" v-if="nDef && eDef===undefined">
                    <hr />
                    <dl class="row">
                        <dt class="col-lg-3 col-sm-4 col-6 bold-text">
                            <span class="dynamic">{{ $t('message.bokmal') }}</span>
                            <span
                                class="reg-text"
                                v-bind:class="[isPictureView ? 'nor-text-picture bold':'nor-text-new' ]"
                            >{{ $t('message.explanation') }}</span>
                        </dt>
                        <dd
                            class="col-lg-9 col-sm-8 col-6 nor-text clsN"
                            data-type="DEF"
                            :lang="languageCodeList.find(x=>x.lang==nDef.lang).langISOCode"
                        >
                            <span v-html="nDef.text" ref="link26"></span>
                            <a class="tts-btn" tabindex="0" role="button" href="javascript:void(0)" onclick="javascript:tts(this);"
                               :aria-label="$t('message.play-tts')">
                                <img class="pointer speaker-image" :alt="$t('message.speech-synthesis_icon')"
                                     src="/images/speaker-small.svg">
                            </a>
                        </dd>
                    </dl>
                </li>
                <li class="col-12 padding" v-if="bDef">
                    <dl class="row">
                        <dt class="col-lg-3 col-sm-4 col-6 bold-text">
                            <span class="dynamic">{{ $t('message.english') }}</span>
                            <span
                                v-if="nDef===undefined && eDef===undefined"
                                class="reg-text"
                                v-bind:class="[isPictureView ? 'nor-text-picture bold':'nor-text-new' ]"
                            >{{ $t('message.explanation') }}</span>
                        </dt>
                        <dd
                            class="col-lg-9 col-sm-8 col-6 nor-text"
                            data-type="DEF"
                            :lang="languageCodeList.find(x=>x.lang=='B').langISOCode"
                            v-html="bDef.text"
                            ref="link27"
                        ></dd>
                    </dl>
                </li>
                <li class="col-12 padding" v-if="lastDef">
                    <dl
                        class="row"
                        v-if="lastDef.lang=='NNY' && lastDef.text.includes('&&')"
                        v-for="(df,index1) in lastDef.text.split('&&').filter(x=>x.match('[^ -]') && x.length !=0).reverse()"
                        :key="df+'-'+index1"
                    >
                        <dt class="col-lg-3 col-sm-4 col-6 bold-text">
                            <span v-if="index1===0" class="dynamic">{{ secondLang }}</span>
                            <span
                                v-if="nDef ===undefined && eDef===undefined && bDef===undefined && index1===0"
                                class="reg-text"
                                v-bind:class="[isPictureView ? 'nor-text-picture bold':'nor-text-new' ]"
                            >{{ $t('message.explanation') }}</span>
                        </dt>
                        <dd
                            class="col-lg-9 col-sm-8 col-6"
                            data-type="DEF"
                            :lang="languageCodeList.find(x=>x.lang==lastDef.lang).langISOCode"
                            v-bind:class="[isLeftAllign ? 'urd-text' : 'nor-text']"
                        >
                            <span v-html="df" ref="link28"></span>
                            <a class="tts-btn" tabindex="0" role="button" href="javascript:void(0)" v-if="lastDef.lang === 'NNY'"
                               onclick="javascript:tts(this);" :aria-label="$t('message.play-tts')">
                                <img
                                    class="pointer speaker-image"
                                    :alt="$t('message.speech-synthesis_icon')" src="/images/speaker-small.svg"

                                >
                            </a>
                        </dd>
                    </dl>
                    <dl class="row" v-else>
                        <dt class="col-lg-3 col-sm-4 col-6 bold-text">
                            <span class="dynamic">{{ secondLang }}</span>
                            <span
                                v-if="nDef ===undefined && eDef===undefined && bDef===undefined"
                                class="reg-text"
                                v-bind:class="[isPictureView ? 'nor-text-picture bold':'nor-text-new' ]"
                            >{{ $t('message.explanation') }}</span>
                        </dt>
                        <dd
                            class="col-lg-9 col-sm-8 col-6"
                            data-type="DEF"
                            :lang="languageCodeList.find(x=>x.lang==lastDef.lang).langISOCode"
                            v-bind:class="[isLeftAllign ? 'urd-text' : 'nor-text']"
                        >
                            <span v-html="lastDef.text" ref="link28"></span>
                            <a class="tts-btn" tabindex="0" role="button" href="javascript:void(0)" v-if="lastDef.lang === 'NNY'"
                               onclick="javascript:tts(this);" :aria-label="$t('message.play-tts')">
                                <img
                                    class="pointer speaker-image"
                                    :alt="$t('message.speech-synthesis_icon')" src="/images/speaker-small.svg"

                                >
                            </a>
                        </dd>
                    </dl>
                </li>
                <li class="col-12 padding" v-if="eTil">
                    <dl class="row">
                        <dt class="col-lg-3 col-sm-4 col-6 bold-text">
                            <span class="dynamic">{{ $t('message.bokmal') }}</span>
                            <span
                                class="reg-text"
                                v-bind:class="[isPictureView ? 'nor-text-picture bold':'nor-text-new' ]"
                            >{{ $t('message.addition') }}</span>
                        </dt>
                        <dd
                            class="col-lg-9 col-sm-8 col-6 nor-text clsN"
                            data-type="TIL"
                            :lang="languageCodeList.find(x=>x.lang==eTil.lang).langISOCode"
                        >
                            <span v-html="eTil.text" ref="link29"></span>
                            <a class="tts-btn" tabindex="0" role="buton" href="javascript:void(0)" onclick="javascript:tts(this);"
                               :aria-label="$t('message.play-tts')">
                                <img class="pointer speaker-image" :alt="$t('message.speech-synthesis_icon')"
                                     src="/images/speaker-small.svg">
                            </a>
                        </dd>
                    </dl>
                </li>
                <li class="col-12 padding" v-if="nTil && eTil===undefined">
                    <dl class="row">
                        <dt class="col-lg-3 col-sm-4 col-6 bold-text">
                            <span class="dynamic">{{ $t('message.bokmal') }}</span>
                            <span
                                class="reg-text"
                                v-bind:class="[isPictureView ? 'nor-text-picture bold':'nor-text-new' ]"
                            >{{ $t('message.addition') }}</span>
                        </dt>
                        <dd
                            class="col-lg-9 col-sm-8 col-6 nor-text clsN"
                            data-type="TIL"
                            :lang="languageCodeList.find(x=>x.lang==nTil.lang).langISOCode"
                        >
                            <span v-html="nTil.text" ref="link30"></span>
                            <a class="tts-btn" tabindex="0" role="button" href="javascript:void(0)" onclick="javascript:tts(this);"
                               :aria-label="$t('message.play-tts')">
                                <img class="pointer speaker-image" :alt="$t('message.speech-synthesis_icon')"
                                     src="/images/speaker-small.svg">
                            </a>
                        </dd>
                    </dl>
                </li>
                <li class="col-12 padding" v-if="bTil">
                    <dl class="row">
                        <dt class="col-lg-3 col-sm-4 col-6 bold-text">
                            <span class="dynamic">{{ $t('message.english') }}</span>
                            <span
                                v-if="nTil ===undefined && eTil ===undefined"
                                class="reg-text"
                                v-bind:class="[isPictureView ? 'nor-text-picture bold':'nor-text-new' ]"
                            >{{ $t('message.addition') }}</span>
                        </dt>
                        <dd
                            class="col-lg-9 col-sm-8 col-6 nor-text clsN"
                            data-type="TIL"
                            :lang="languageCodeList.find(x=>x.lang=='B').langISOCode"
                            v-html="bTil.text"
                            ref="link31"
                        >
                            <a class="tts-btn" tabindex="0" role="button" href="javascript:void(0)" onclick="javascript:tts(this);"
                               :aria-label="$t('message.play-tts')">
                                <img class="pointer speaker-image" :alt="$t('message.speech-synthesis_icon')"
                                     src="/images/speaker-small.svg">
                            </a>
                        </dd>
                    </dl>
                </li>
                <li class="col-12 padding" v-if="lastTil">
                    <dl
                        class="row"
                        v-if="lastTil.lang=='NNY' && lastTil.text.includes('&&')"
                        v-for="(til,index1) in lastTil.text.split('&&').filter(x=>x.match('[^ -]') && x.length !=0).reverse()"
                        :key="til+'-'+index1"
                    >
                        <dt class="col-lg-3 col-sm-4 col-6 bold-text">
                            <span v-if="index1===0" class="dynamic">{{ secondLang }}</span>
                            <span
                                v-if="nTil ===undefined && eTil ===undefined && bTil===undefined && index1===0"
                                class="reg-text"
                                v-bind:class="[isPictureView ? 'nor-text-picture bold':'nor-text-new' ]"
                            >{{ $t('message.addition') }}</span>
                        </dt>
                        <dd
                            class="col-lg-9 col-sm-8 col-6 clsN"
                            v-bind:class="[isLeftAllign ? 'urd-text' : 'nor-text']"
                            data-type="TIL"
                            :lang="languageCodeList.find(x=>x.lang==lastTil.lang).langISOCode"
                        >
                            <span v-html="til" ref="link32"></span>
                            <a class="tts-btn" tabindex="0" href="javascript:void(0)" v-if="lastTil.lang === 'NNY'"
                               onclick="javascript:tts(this);" :aria-label="$t('message.play-tts')">
                                <img
                                    class="pointer speaker-image"
                                    :alt="$t('message.speech-synthesis_icon')" src="/images/speaker-small.svg"
                                >
                            </a>
                        </dd>
                    </dl>
                    <dl class="row" v-else>
                        <dt class="col-lg-3 col-sm-4 col-6 bold-text">
                            <span class="dynamic">{{ secondLang }}</span>
                            <span
                                v-if="nTil ===undefined && eTil ===undefined && bTil===undefined"
                                class="reg-text"
                                v-bind:class="[isPictureView ? 'nor-text-picture bold':'nor-text-new' ]"
                            >{{ $t('message.addition') }}</span>
                        </dt>
                        <dd
                            class="col-lg-9 col-sm-8 col-6 clsN"
                            v-bind:class="[isLeftAllign ? 'urd-text' : 'nor-text']"
                            data-type="TIL"
                            :lang="languageCodeList.find(x=>x.lang==lastTil.lang).langISOCode"
                        >
                            <span v-html="lastTil.text" ref="link32"></span>
                            <a class="tts-btn" tabindex="0" role="button" href="javascript:void(0)" v-if="lastTil.lang === 'NNY'"
                               onclick="javascript:tts(this);" :aria-label="$t('message.play-tts')">
                                <img
                                    class="pointer speaker-image"
                                    :alt="$t('message.speech-synthesis_icon')" src="/images/speaker-small.svg"
                                >
                            </a>
                        </dd>
                    </dl>
                </li>
                <hr v-if="eks.length || idi.length || sms.length">
                <li class="col-12 padding" v-for="(eks,index) in eks" :key="eks.text+'-'+index" v-if="eks.text != ''">
                    <hr v-if="index>0 && showDynamicHrInList(eks)" class="dyn-divider">
                    <dl class="row" v-if="eks.lang==='E'">
                        <dt class="col-lg-3 col-sm-4 col-6 bold-text">
                            <span class="dynamic">{{ $t('message.bokmal') }}</span>
                            <span
                                v-if="index === 0"
                                class="reg-text"
                                v-bind:class="[isPictureView ? 'nor-text-picture bold':'nor-text-new' ]"
                            >{{ $t('message.example') }}</span>
                        </dt>
                        <dd
                            class="col-lg-9 col-sm-8 col-6 nor-text clsE"
                            data-type="EKS"
                            :lang="languageCodeList.find(x=>x.lang==eks.lang).langISOCode"
                        >
                            <span v-html="eks.text" ref="link33"></span>
                            <a class="tts-btn" tabindex="0" role="button" href="javascript:void(0)" onclick="javascript:tts(this);"
                               :aria-label="$t('message.play-tts')">
                                <img class="pointer speaker-image"
                                     :alt="$t('message.speech-synthesis_icon')"
                                     src="/images/speaker-small.svg">
                            </a>
                        </dd>
                    </dl>
                    <dl class="row" v-else-if="eks.lang==='N'">
                        <dt class="col-lg-3 col-sm-4 col-6 bold-text">
                            <span class="dynamic">{{ $t('message.bokmal') }}</span>
                            <span
                                v-if="index === 0"
                                class="reg-text"
                                v-bind:class="[isPictureView ? 'nor-text-picture bold':'nor-text-new' ]"
                            >{{ $t('message.example') }}</span>
                        </dt>
                        <dd
                            class="col-lg-9 col-sm-8 col-6 nor-text clsE"
                            data-type="EKS"
                            :lang="languageCodeList.find(x=>x.lang==eks.lang).langISOCode"
                        >
                            <span v-html="eks.text" ref="link34"></span>
                            <a class="tts-btn" tabindex="0" role="button" href="javascript:void(0)" onclick="javascript:tts(this);"
                               :aria-label="$t('message.play-tts')">
                                <img class="pointer speaker-image" :alt="$t('message.speech-synthesis_icon')"
                                     src="/images/speaker-small.svg">
                            </a>
                        </dd>
                    </dl>
                    <dl class="row" v-else-if="eks.lang==='B'">
                        <dt class="col-lg-3 col-sm-4 col-6 bold-text">
                            <span class="dynamic">{{ $t('message.english') }}</span>
                            <span
                                v-if="index === 0"
                                class="reg-text"
                                v-bind:class="[isPictureView ? 'nor-text-picture bold':'nor-text-new' ]"
                            >{{ $t('message.example') }}</span>
                        </dt>
                        <dd
                            class="col-lg-9 col-sm-8 col-6 nor-text clsE"
                            data-type="EKS"
                            :lang="languageCodeList.find(x=>x.lang=='B').langISOCode"
                            v-html="eks.text"
                            ref="link35"
                        >
                            <a class="tts-btn" tabindex="0" role="button" href="javascript:void(0)" onclick="javascript:tts(this);"
                               :aria-label="$t('message.play-tts')">
                                <img class="pointer speaker-image" :alt="$t('message.speech-synthesis_icon')"
                                     src="/images/speaker-small.svg">
                            </a>
                        </dd>
                    </dl>
                    <dl
                        class="row"
                        v-else-if="eks.lang==='NNY' && eks.text.includes('&&')"
                        v-for="(ekss,index1) in eks.text.split('&&').filter(x=>x.match('[^ -]') && x.length !=0).reverse()"
                        :key="ekss+'-'+index1"
                    >
                        <dt
                            class="col-lg-3 col-sm-4 col-6 bold-text"
                            style="text-transform: capitalize;"
                        >
                            <span v-if="index1===0" class="dynamic">{{ secondLang }}</span>
                        </dt>
                        <dd
                            class="col-lg-9 col-sm-8 col-6 clsE"
                            v-bind:class="[isLeftAllign ? 'urd-text' : 'nor-text']"
                            data-type="EKS"
                            :lang="languageCodeList.find(x=>x.lang==eks.lang).langISOCode"
                        >
                            <span v-html="ekss" ref="link36"></span>
                            <a class="tts-btn" tabindex="0" role="button" href="javascript:void(0)" v-if="eks.lang === 'NNY'"
                               onclick="javascript:tts(this);" :aria-label="$t('message.play-tts')">
                                <img
                                    class="pointer speaker-image"
                                    :alt="$t('message.speech-synthesis_icon')" src="/images/speaker-small.svg"
                                >
                            </a>
                        </dd>
                    </dl>
                    <dl class="row" v-else-if="eks.text != ''">
                        <dt
                            class="col-lg-3 col-sm-4 col-6 bold-text"
                            style="text-transform: capitalize;"
                        >
                            <span class="dynamic">{{ secondLang }}</span>
                        </dt>
                        <dd
                            class="col-lg-9 col-sm-8 col-6 clsE"
                            v-bind:class="[isLeftAllign ? 'urd-text' : 'nor-text']"
                            data-type="EKS"
                            :lang="languageCodeList.find(x=>x.lang==eks.lang).langISOCode"
                        >
                            <span v-html="eks.text" ref="link36"></span>
                            <a class="tts-btn" tabindex="0" role="button" href="javascript:void(0)" v-if="eks.lang === 'NNY'"
                               onclick="javascript:tts(this);" :aria-label="$t('message.play-tts')">
                                <img
                                    class="pointer speaker-image"
                                    :alt="$t('message.speech-synthesis_icon')" src="/images/speaker-small.svg"
                                >
                            </a>
                        </dd>
                    </dl>
                </li>
                <hr v-if="(eks.length && idi.length) || (eks.length && sms.length)">
                <li class="col-12 padding" v-for="(idi,index) in idi" :key="idi.text+'-'+index" v-if="idi.text != ''">
                    <hr v-if="index>0 && showDynamicHrInList(idi)" class="dyn-divider">
                    <dl class="row" v-if="idi.lang==='E'">
                        <dt class="col-lg-3 col-sm-4 col-6 bold-text">
                            <span class="dynamic">{{ $t('message.bokmal') }}</span>
                            <span
                                v-if="index === 0"
                                class="reg-text"
                                v-bind:class="[isPictureView ? 'nor-text-picture bold':'nor-text-new' ]"
                            >{{ $t('message.expression') }}</span>
                        </dt>
                        <dd
                            class="col-lg-9 col-sm-8 col-6 nor-text clsE"
                            data-type="IDI"
                            :lang="languageCodeList.find(x=>x.lang==idi.lang).langISOCode"
                        >
                            <span v-html="idi.text" ref="link37"></span>
                            <a class="tts-btn" tabindex="0" role="button" href="javascript:void(0)" onclick="javascript:tts(this);"
                               :aria-label="$t('message.play-tts')">
                                <img class="pointer speaker-image" :alt="$t('message.speech-synthesis_icon')"
                                     src="/images/speaker-small.svg">
                            </a>
                        </dd>
                    </dl>
                    <dl class="row" v-else-if="idi.lang==='N'">
                        <dt class="col-lg-3 col-sm-4 col-6 bold-text">
                            <span class="dynamic">{{ $t('message.bokmal') }}</span>
                            <span
                                v-if="index === 0"
                                class="reg-text"
                                v-bind:class="[isPictureView ? 'nor-text-picture bold':'nor-text-new' ]"
                            >{{ $t('message.expression') }}</span>
                        </dt>
                        <dd
                            class="col-lg-9 col-sm-8 col-6 nor-text clsE"
                            data-type="IDI"
                            :lang="languageCodeList.find(x=>x.lang==idi.lang).langISOCode"
                        >
                            <span v-html="idi.text" ref="link38"></span>
                            <a class="tts-btn" tabindex="0" role="button" href="javascript:void(0)" onclick="javascript:tts(this);"
                               :aria-label="$t('message.play-tts')">
                                <img class="pointer speaker-image" :alt="$t('message.speech-synthesis_icon')"
                                     src="/images/speaker-small.svg">
                            </a>
                        </dd>
                    </dl>
                    <dl class="row" v-else-if="idi.lang==='B'">
                        <dt class="col-lg-3 col-sm-4 col-6 bold-text">
                            <span class="dynamic">{{ $t('message.english') }}</span>
                            <span
                                v-if="index === 0"
                                class="reg-text"
                                v-bind:class="[isPictureView ? 'nor-text-picture bold':'nor-text-new' ]"
                            >{{ $t('message.expression') }}</span>
                        </dt>
                        <dd
                            class="col-lg-9 col-sm-8 col-6 nor-text clsE"
                            data-type="IDI"
                            :lang="languageCodeList.find(x=>x.lang==idi.lang).langISOCode"
                            v-html="idi.text"
                            ref="link39"
                        >
                            <a class="tts-btn" tabindex="0" role="button" href="javascript:void(0)" onclick="javascript:tts(this);"
                               :aria-label="$t('message.play-tts')">
                                <img class="pointer speaker-image" :alt="$t('message.speech-synthesis_icon')"
                                     src="/images/speaker-small.svg">
                            </a>
                        </dd>
                    </dl>
                    <dl
                        class="row"
                        v-else-if="idi.lang==='NNY' && idi.text.includes('&&')"
                        v-for="(idis,index1) in idi.text.split('&&').filter(x=>x.match('[^ -]') && x.length!=0).reverse()"
                        :key="idis+'-'+index1"
                    >
                        <dt
                            class="col-lg-3 col-sm-4 col-6 bold-text"
                            style="text-transform: capitalize;"
                        >
                            <span v-if="index1===0" class="dynamic">{{ secondLang }}</span>
                        </dt>
                        <dd
                            class="col-lg-9 col-sm-8 col-6 clsE"
                            v-bind:class="[isLeftAllign ? 'urd-text' : 'nor-text']"
                            data-type="IDI"
                            :lang="languageCodeList.find(x=>x.lang==idi.lang).langISOCode"
                        >
                            <span v-html="idis" ref="link40"></span>
                            <a class="tts-btn" tabindex="0" v-if="idi.lang === 'NNY'" href="javascript:void(0)"
                               onclick="javascript:tts(this);" :aria-label="$t('message.play-tts')">
                                <img
                                    class="pointer speaker-image"
                                    :alt="$t('message.speech-synthesis_icon')" src="/images/speaker-small.svg"
                                >
                            </a>
                        </dd>
                    </dl>
                    <dl class="row" v-else-if="idi.text != ''">
                        <dt
                            class="col-lg-3 col-sm-4 col-6 bold-text"
                            style="text-transform: capitalize;"
                        >
                            <span class="dynamic">{{ secondLang }}</span>
                        </dt>
                        <dd
                            class="col-lg-9 col-sm-8 col-6 clsE"
                            v-bind:class="[isLeftAllign ? 'urd-text' : 'nor-text']"
                            data-type="IDI"
                            :lang="languageCodeList.find(x=>x.lang==idi.lang).langISOCode"
                        >
                            <span v-html="idi.text" ref="link40"></span>
                            <a class="tts-btn" tabindex="0" role="button" v-if="idi.lang === 'NNY'" href="javascript:void(0)"
                               onclick="javascript:tts(this);" :aria-label="$t('message.play-tts')">
                                <img
                                    class="pointer speaker-image"
                                    :alt="$t('message.speech-synthesis_icon')" src="/images/speaker-small.svg"
                                >
                            </a>
                        </dd>
                    </dl>
                </li>
                <hr v-if="idi.length && sms.length">
                <li class="col-12 padding" v-for="(sms1,index) in sms" :key="sms1.text+'-'+index" v-if="sms1.text != ''">
                    <hr v-if="index>0 && showDynamicHrInList(sms1)" class="dyn-divider">
                    <dl class="row" v-if="sms1.lang==='E'">
                        <dt class="col-lg-3 col-sm-4 col-6 bold-text">
                            <span class="dynamic">{{ $t('message.bokmal') }}</span>
                            <span
                                v-if="index === 0"
                                class="reg-text"
                                v-bind:class="[isPictureView ? 'nor-text-picture bold':'nor-text-new' ]"
                            >{{ $t('message.multiword') }}</span>
                        </dt>
                        <dd
                            class="col-lg-9 col-sm-8 col-6 nor-text clsE"
                            data-type="sms1"
                            :lang="languageCodeList.find(x=>x.lang==sms1.lang).langISOCode"
                        >
                            <span v-html="sms1.text" ref="link41"></span>
                            <!-- <span v-if="sms1.image!==undefined">
                              <img
                                v-for="(Id,index2) in getSmsId(sms1.image)"
                                v-on:click="getImage(Id, getName(extractContent(sms1.text.replace('|',''))), sms1.id, displayLang)"
                                class="pointer"
                                :key="Id+'-'+index2"
                                src="/images/image-link.png"
                              >&nbsp;
                            </span> -->
                            <a class="tts-btn" tabindex="0" role="button" href="javascript:void(0)" onclick="javascript:tts(this);"
                               :aria-label="$t('message.play-tts')">
                                <img class="pointer speaker-image" :alt="$t('message.speech-synthesis_icon')"
                                     src="/images/speaker-small.svg">
                            </a>
                        </dd>
                    </dl>
                    <dl class="row" v-else-if="sms1.lang==='N'">
                        <dt class="col-lg-3 col-sm-4 col-6 bold-text">
                            <span class="dynamic">{{ $t('message.bokmal') }}</span>
                            <span
                                v-if="index === 0"
                                class="reg-text"
                                v-bind:class="[isPictureView ? 'nor-text-picture bold':'nor-text-new' ]"
                            >{{ $t('message.multiword') }}</span>
                        </dt>
                        <dd
                            class="col-lg-9 col-sm-8 col-6 nor-text clsE"
                            data-type="SMS"
                            :lang="languageCodeList.find(x=>x.lang==sms1.lang).langISOCode"
                        >
                            <span v-html="sms1.text" ref="link42"></span>
                            <a class="tts-btn" tabindex="0" role="button" href="javascript:void(0)" onclick="javascript:tts(this);"
                               :aria-label="$t('message.play-tts')">
                                <img class="pointer speaker-image" :alt="$t('message.speech-synthesis_icon')"
                                     src="/images/speaker-small.svg">
                            </a>
                        </dd>
                    </dl>
                    <dl class="row" v-else-if="sms1.lang==='B'">
                        <dt class="col-lg-3 col-sm-4 col-6 bold-text">
                            <span class="dynamic">{{ $t('message.english') }}</span>
                            <span
                                v-if="index === 0"
                                class="reg-text"
                                v-bind:class="[isPictureView ? 'nor-text-picture bold':'nor-text-new' ]"
                            >{{ $t('message.multiword') }}</span>
                        </dt>
                        <dd
                            class="col-lg-9 col-sm-8 col-6 nor-text clsE"
                            data-type="SMS"
                            :lang="languageCodeList.find(x=>x.lang=='B').langISOCode"
                            v-html="sms1.text"
                            ref="link43"
                        >
                            <a class="tts-btn" tabindex="0" role="button" href="javascript:void(0)" onclick="javascript:tts(this);"
                               :aria-label="$t('message.play-tts')">
                                <img class="pointer speaker-image" :alt="$t('message.speech-synthesis_icon')"
                                     src="/images/speaker-small.svg">
                            </a>
                        </dd>
                    </dl>
                    <dl
                        class="row"
                        v-else-if="sms1.lang=='NNY' && sms1.text.includes('&&')"
                        v-for="(sms1s,index1) in sms1.text.split('&&').filter(x=>x.match('[^ -]') && x.length!=0).reverse()"
                        :key="sms1s+'-'+index1"
                    >
                        <dt
                            class="col-lg-3 col-sm-4 col-6 bold-text"
                            style="text-transform: capitalize;"
                        >
                            <span v-if="index1===0" class="dynamic">{{ secondLang }}</span>
                        </dt>
                        <dd
                            class="col-lg-9 col-sm-8 col-6 clsE"
                            v-bind:class="[isLeftAllign ? 'urd-text' : 'nor-text']"
                            data-type="SMS"
                            :lang="languageCodeList.find(x=>x.lang==sms1.lang).langISOCode"
                        >
                            <span v-html="sms1s" ref="link44"></span>
                            <a class="tts-btn" tabindex="0" role="button" href="javascript:void(0)" v-if="sms1.lang === 'NNY'"
                               onclick="javascript:tts(this);" :aria-label="$t('message.play-tts')">
                                <img
                                    class="pointer speaker-image"
                                    :alt="$t('message.speech-synthesis_icon')" src="/images/speaker-small.svg"
                                >
                            </a>
                        </dd>
                    </dl>
                    <dl class="row" v-else>
                        <dt
                            class="col-lg-3 col-sm-4 col-6 bold-text"
                            style="text-transform: capitalize;"
                        >
                            <span class="dynamic">{{ secondLang }}</span>
                        </dt>
                        <dd
                            class="col-lg-9 col-sm-8 col-6 clsE"
                            v-bind:class="[isLeftAllign ? 'urd-text' : 'nor-text']"
                            data-type="sms"
                            :lang="languageCodeList.find(x=>x.lang==sms1.lang).langISOCode"
                        >
                            <span v-html="sms1.text"
                                  ref="link44"></span>
                            <a class="tts-btn" tabindex="0" role="button" href="javascript:void(0)" v-if="sms1.lang === 'NNY'"
                               onclick="javascript:tts(this);" :aria-label="$t('message.play-tts')">
                                <img
                                    class="pointer speaker-image"
                                    :alt="$t('message.speech-synthesis_icon')" src="/images/speaker-small.svg"
                                >
                            </a>
                        </dd>
                    </dl>
                </li>
            </ul>
        </div>
    </div>
</template>

<script>

import norskOrdbankResult from "@/components/NorskOrdbankResult.vue";
import NorskOrdbankResultBlocks from "@/components/NorskOrdbankResultBlocks.vue";
import NorskOrdbankResultPronunciation from "@/components/NorskOrdbankResultPronunciation.vue";
import Pronunciation from "@/components/Pronunciation.vue";
import PartOfSpeachHeader from "@/components/PartOfSpeachHeader.vue";

export default {
    name: "pictureResultBok",
    computed: {
        norskOrdbank() {
            return norskOrdbank
        }
    },
    components: {
        NorskOrdbankResultPronunciation,
        norskOrdbankResult,
        NorskOrdbankResultBlocks,
        Pronunciation,
        PartOfSpeachHeader
    },
    data() {
        return {
            cache: {},
            xres: null,
            eLem: {},
            eKat: {},
            eDef: {},
            eKom: {},
            eTil: {},
            eMor: {},
            eAlt: {},
            eUtt: {},
            eGrm: {},
            nLem: {},
            nKat: {},
            nDef: {},
            nKom: {},
            nTil: {},
            nMor: {},
            nAlt: {},
            nUtt: {},
            nGrm: {},
            bLem: {},
            bKat: {},
            bDef: {},
            bKom: {},
            bTil: {},
            bMor: {},
            bAlt: {},
            bGrm: {},
            lastLem: {},
            lastKat: {},
            lastDef: {},
            lastKom: {},
            lastTil: {},
            lastMor: {},
            lastAlt: [],
            lastUtt: {},
            lastGrm: {},
            sms: [],
            eks: [],
            idi: [],
            Div: [],
            arrStr: [],
            imgs: [],
            isLeftAllign: false,
            isPictureView: false,
            linkWord: "",
            refElements: [],
            routehref: "",
            languageCodeList: [
                {language: 'bokmal', lang: 'E', langISOCode: 'nb'},
                {language: 'bokmal', lang: 'N', langISOCode: 'nb'},
                {language: 'nynorsk', lang: 'NNY', langISOCode: 'nn'},
                {language: 'arabic', lang: 'ARA', langISOCode: 'ar'},
                {language: 'dari', lang: 'PRS', langISOCode: 'prs'},
                {language: 'burmese', lang: 'BUR', langISOCode: 'my'},
                {language: 'kurdish (kurmanji)', lang: 'KKU', langISOCode: 'kmr'},
                {language: 'kurdish (sorani)', lang: 'KSO', langISOCode: 'ckb'},
                {language: 'lithuanian', lang: 'LIT', langISOCode: 'lt'},
                {language: 'persian', lang: 'PER', langISOCode: 'fa'},
                {language: 'polish', lang: 'POL', langISOCode: 'pl'},
                {language: 'russian', lang: 'RU', langISOCode: 'ru'},
                {language: 'somali', lang: 'SOM', langISOCode: 'so'},
                {language: 'tagalog', lang: 'TGL', langISOCode: 'tl'},
                {language: 'tamil', lang: 'T', langISOCode: 'ta'},
                {language: 'thai', lang: 'TH', langISOCode: 'th'},
                {language: 'tigrinya', lang: 'TIR', langISOCode: 'ti'},
                {language: 'turkish', lang: 'TUR', langISOCode: 'tr'},
                {language: 'ukrainsk', lang: 'UKR', langISOCode: 'uk'},
                {language: 'ukrainian', lang: 'UKR', langISOCode: 'uk'},
                {language: 'urdu', lang: 'UR', langISOCode: 'ur'},
                {language: 'vietnamese', lang: 'VIE', langISOCode: 'vi'},
                {language: 'english', lang: 'B', langISOCode: 'en'}
            ]
        };
    },
    props: {
        Val: Array,
        lang: String,
        secondLang: String,
        displayLang: String,
        loaded: Boolean,
        isPicturepage: Boolean,
        dictionary: String,
        ordbankList: Object,
        partOfSpeachInfo: Object,
        resultIndex: String,
        includeEngLanguage: Boolean,
        searchInput: {
            type: String,
            default: ""
        }
    },
    mounted() {
        if (this.searchInput === "" || this.searchInput === null) {
            this.isPictureView = true;
        }

        if (this.displayLang === "bokmål") {
            Array.from(document.querySelectorAll(".dynamic")).forEach(
                a => (a.style.display = "none")
            );
        }
        this.refElements = this.$refs;
        this.addOnClickToHyperlink();
    },
    updated() {
        if (this.displayLang === "bokmål") {
            Array.from(document.querySelectorAll(".dynamic")).forEach(
                a => (a.style.display = "none")
            );
        }
        this.refElements = this.$refs;
        this.addOnClickToHyperlink();
    },
    created() {
        if (this.Val.length) {
            this.xres = this.Val;
            this.mapIntoHtml();
        }
    },
    watch: {
        Val: function (newVal) {
            this.xres = newVal;
            this.mapIntoHtml();
        }
    },
    methods: {
        //#region function to filter the data into the different objects according to the different types
        //words are mapped to the correct object i.e.eLem,eKat....  based on there type
        filterData(lang) {
            var _this = this;
            this.eLem = lang.find(function (obj) {
                return obj.type === "E-lem" && obj.text.length > 0;
            });
            this.eKat = lang.find(function (obj) {
                return obj.type === "E-kat" && obj.text.length > 0;
            });
            this.eDef = lang.find(function (obj) {
                return obj.type === "E-def" && obj.text.length > 0;
            });
            this.eKom = lang.find(function (obj) {
                if (!(obj.type == "E-kom" && obj.text.match(/^[a-z]+[-]+[0-9]*$/g))) {
                    return obj.type === "E-kom" && obj.text.length > 0;
                }
            });
            this.eTil = lang.find(function (obj) {
                return obj.type === "E-til" && obj.text.length > 0;
            });
            this.eMor = lang.find(function (obj) {
                return obj.type === "E-mor" && obj.text.length > 0;
            });
            this.eAlt = lang.find(function (obj) {
                return obj.type === "E-alt" && obj.text.length > 0;
            });
            this.eUtt = lang.find(function (obj) {
                return obj.type === "E-utt" && obj.text.length > 0;
            });
            this.eGrm = lang.find(function (obj) {
                return obj.type === "E-grm" && obj.text.length > 0;
            });

            this.nLem = lang.find(function (obj) {
                return obj.type === "N-lem" && obj.text.length > 0;
            });
            this.nKat = lang.find(function (obj) {
                return obj.type === "N-kat" && obj.text.length > 0;
            });
            this.nDef = lang.find(function (obj) {
                return obj.type === "N-def" && obj.text.length > 0;
            });
            this.nKom = lang.find(function (obj) {
                if (!(obj.type == "N-kom" && obj.text.match(/^[a-z]+[-]+[0-9]*$/g))) {
                    return obj.type === "N-kom" && obj.text.length > 0;
                }
            });
            this.nTil = lang.find(function (obj) {
                return obj.type === "N-til" && obj.text.length > 0;
            });
            this.nMor = lang.find(function (obj) {
                return obj.type === "N-mor" && obj.text.length > 0;
            });

            this.nAlt = lang.find(function (obj) {
                return obj.type === "N-alt" && obj.text.length > 0;
            });
            this.nUtt = lang.find(function (obj) {
                return obj.type === "N-utt" && obj.text.length > 0;
            });
            this.nGrm = lang.find(function (obj) {
                return obj.type === "N-grm" && obj.text.length > 0;
            });

            this.bLem = lang.find(function (obj) {
                return obj.type === "B-lem" && obj.text.length > 0;
            });
            this.bKat = lang.find(function (obj) {
                return obj.type === "B-kat" && obj.text.length > 0;
            });
            this.bDef = lang.find(function (obj) {
                return obj.type === "B-def" && obj.text.length > 0;
            });
            this.bKom = lang.find(function (obj) {
                if (!(obj.type == "B-kom" && obj.text.match(/^[a-z]+[-]+[0-9]*$/g))) {
                    return obj.type === "B-kom" && obj.text.length > 0;
                }
            });
            this.bTil = lang.find(function (obj) {
                return obj.type === "B-til" && obj.text.length > 0;
            });
            this.bMor = lang.find(function (obj) {
                return obj.type === "B-mor" && obj.text.length > 0;
            });
            this.bAlt = lang.find(function (obj) {
                return obj.type === "B-alt" && obj.text.length > 0;
            });
            this.bGrm = lang.find(function (obj) {
                return obj.type === "B-grm" && obj.text.length > 0;
            });

            this.lastLem = lang.find(function (obj) {
                if (
                    obj.lang == "UR" ||
                    obj.lang == "ARA" ||
                    obj.lang == "KSO" ||
                    obj.lang == "PER" ||
                    obj.lang == "PRS"
                ) {
                    _this.isLeftAllign = true;
                }
                return (
                    obj.type !== "B-lem" &&
                    obj.type !== "E-lem" &&
                    obj.type !== "N-lem" &&
                    obj.type.indexOf("lem") > 0 &&
                    obj.text.length > 0
                );
            });
            this.lastkat = lang.find(function (obj) {
                return (
                    obj.type !== "B-kat" &&
                    obj.type !== "E-kat" &&
                    obj.type !== "N-kat" &&
                    obj.type.indexOf("kat") > 0 &&
                    obj.text.length > 0
                );
            });
            if (this.lastkat === undefined && this.lastLem !== undefined &&
                this.lastLem.type !== undefined && this.lastLem.type === 'Nny-lem') {
                this.lastkat = lang.find(function(obj) {
                    return (obj.type === "E-kat" || obj.type === "N-kat") && obj.text.length > 0;
                });
            }

            this.lastDef = lang.find(function (obj) {
                return (
                    obj.type !== "B-def" &&
                    obj.type !== "E-def" &&
                    obj.type !== "N-def" &&
                    obj.type.indexOf("def") > 0 &&
                    obj.text.length > 0
                );
            });

            this.lastKom = lang.find(function (obj) {
                if (!(
                    obj.type !== "B-kom" &&
                    obj.type !== "E-kom" &&
                    obj.type !== "N-kom" &&
                    obj.type.indexOf("kom") > 0 &&
                    obj.text.match(/^[a-z]+[-]+[0-9]*$/g) &&
                    obj.text.length > 0
                )) {
                    return (
                        obj.type !== "B-kom" &&
                        obj.type !== "E-kom" &&
                        obj.type !== "N-kom" &&
                        obj.type.indexOf("kom") > 0 &&
                        obj.text.length > 0
                    );
                }
            });
            this.lastTil = lang.find(function (obj) {
                return (
                    obj.type !== "B-til" &&
                    obj.type !== "E-til" &&
                    obj.type !== "N-til" &&
                    obj.type.indexOf("til") > 0 &&
                    obj.text.length > 0
                );
            });
            this.lastMor = lang.find(function (obj) {
                return (
                    obj.type !== "B-mor" &&
                    obj.type !== "E-mor" &&
                    obj.type !== "N-mor" &&
                    obj.type.indexOf("mor") > 0 &&
                    obj.text.length > 0
                );
            });

            this.lastAlt = _.filter(lang, function (item) {
                return (
                    item.type !== "B-alt" &&
                    item.type !== "E-alt" &&
                    item.type !== "N-alt" &&
                    item.type.indexOf("alt") > 0 &&
                    item.text.length > 0
                );
            });

            this.lastUtt = lang.find(function (obj) {
                return (
                    obj.type !== "B-utt" &&
                    obj.type !== "E-utt" &&
                    obj.type !== "N-utt" &&
                    obj.type.indexOf("utt") > 0 &&
                    obj.text.length > 0
                );
            });
            this.lastGrm = lang.find(function (obj) {
                return (
                    obj.type !== "B-grm" &&
                    obj.type !== "E-grm" &&
                    obj.type !== "N-grm" &&
                    obj.type.indexOf("grm") > 0 &&
                    obj.text.length > 0
                );
            });

            this.sms = this.filterDynamicValues('sms', lang);
            this.eks = this.filterDynamicValues('eks', lang);
            this.idi = this.filterDynamicValues('idi', lang);
        },
        //#endregion

        filterDynamicValues(fieldName, lang) {
            let langList = [];

            let values = _.filter(lang, function (item) {
                const hasInclude = _.includes(item.type, "-" + fieldName);
                if (hasInclude && !langList.includes(item.lang)) {
                    langList.push(item.lang);
                }
                return hasInclude;
            });

            values = _.sortBy(values, function (o) {
                return o.sub_id;
            });

            values = this.getDistinctValue(values, langList);

            return values;
        },

        sortDistinctValue(list) {
            list.sort((a, b) => {
                if (a.index > b.index) {
                    return 1;
                } else if (a.index === b.index) {
                    if (a.sub_id !== undefined && b.sub_id !== undefined) {

                        if (a.sub_id > b.sub_id) {
                            return 1;
                        } else {
                            return -1;
                        }
                    } else {
                        return -1;
                    }
                } else {
                    return -1;
                }
            });

            return list;
        },
        capitalizeFirstLetter(str) {
            if (typeof str !== 'string' || str.length === 0) {
                return str; // Handle empty strings or non-string inputs
            }
            return str.charAt(0).toUpperCase() + str.slice(1);
        },
        showDynamicHrInList(item) {
            if (item.lang === 'N' || item.lang === 'E') {
                return true;
            } else if (item.showHr !== undefined && item.showHr === true) {
                return true;
            }

            return false;
        },
        repairValListValues(val) {
            let status = false;
            let lastSubId = 0;
            let lastLang = '';
            for (let i in val) {
                let subId = val[i].sub_id;
                let lang = val[i].lang;

                if (['E', 'N'].includes(lastLang) && (subId - 1) === lastSubId) {
                    status = false;
                    if (!val[i].text) {
                        val.splice(i, 1);
                        status = true;
                    } else if (!val[(i - 1)].text) {
                        val.splice((i - 1), 1);
                        status = true;
                    }

                    if (status) {
                        let returnValue = {
                            'status': status,
                            'value': val,
                        };
                        return returnValue;
                    }
                }
                lastSubId = subId;
                lastLang = lang;
            }

            let returnValue = {
                'status': status,
                'value': val,
            };

            return returnValue;
        },
        getCleanNboVal(val) {
            let retListVal = {};
            do {
                retListVal = this.repairValListValues(val);
                if (retListVal.status === true) {
                    val = retListVal.value;
                }
            } while (retListVal.status === true);

            return val;
        },

        //#region function to reorder the text of type sms,idi,eks according to the sub_id,first-language and second-language
        getDistinctValue(val, langListValues = []) {
            if (!val) {
                return;
            }

            val = this.getCleanNboVal(val);

            let arr_result = [];
            let bok = [],
                eng = [],
                last_lang = [],
                hasLangEng = false,
                langOtherValue = '';

            if (langListValues.includes('B')) {
                hasLangEng = true;
            }

            for (let i in langListValues) {
                if (!(['E', 'N', 'B'].includes(langListValues[i]))) {
                    langOtherValue = langListValues[i];
                }
            }

            let langIndexMap = {};
            for (let i in val) {
                if (val[i]['index'] !== undefined && typeof val[i]['index'] === 'number' ) {
                    let lang = val[i]['lang'];
                    let index = val[i]['index'];
                    if (langIndexMap[lang] === undefined) {
                        langIndexMap[lang] = {};
                    }
                    langIndexMap[lang][index] = true;
                }
            }

            let bokHasIndex = false;
            let engHasIndex = false;
            let otherHasIndex = false;

            let rowIndex = 0;
            let firstLangList = [];
            let langList = {};
            let hasBokmal = false;
            for (let i = 0; i < val.length; i++) {
                if (val[i].lang !== undefined) {
                    let lang = val[i].lang;

                    if (!firstLangList.length) {
                        if (val[i].lang === 'E' || val[i].lang === 'N') {
                            firstLangList.push('E');
                            firstLangList.push('N');
                            hasBokmal = true;
                        }
                    } else if (firstLangList.includes(val[i].lang)) {
                        if (hasLangEng && langList[rowIndex]['B'] === undefined &&
                            !this.hasLangIndexMap(langIndexMap, 'B', rowIndex)) {
                            let langListInfo = this.getLangListInfoFromLangListRow('B', langList[rowIndex]);
                            if (langListInfo) {
                                let langIndex = langListInfo['index'];
                                let itemRowIndex = rowIndex;
                                if (langIndexMap['B'] !== undefined) {
                                    itemRowIndex = this.getFirstFreeRowIndex(langIndexMap['B'], rowIndex);
                                    langIndexMap['B'][itemRowIndex] = true;
                                    langIndex = itemRowIndex;
                                }

                                langList[rowIndex]['B'] = {
                                    'entry': langListInfo['entry'],
                                    'id': langListInfo['id'],
                                    'index': langIndex,
                                    'lang': 'B',
                                    'text': '',
                                    'type': langListInfo['type']
                                }
                            }
                        }

                        if (langOtherValue !== '' &&
                            !['N', 'E', 'B', 'E-N'].includes(langOtherValue) &&
                            langList[rowIndex][langOtherValue] === undefined &&
                            !this.hasLangIndexMap(langIndexMap, langOtherValue, rowIndex)) {
                            let langListInfo = this.getLangListInfoFromLangListRow('langOtherValue', langList[rowIndex]);
                            if (langListInfo) {
                                let langIndex = langListInfo['index'];
                                let itemRowIndex = rowIndex;
                                if (langIndexMap[langOtherValue] !== undefined) {
                                    itemRowIndex = this.getFirstFreeRowIndex(langIndexMap[langOtherValue], rowIndex);
                                    langIndexMap[langOtherValue][itemRowIndex] = true;
                                    langIndex = itemRowIndex;
                                }

                                langList[rowIndex][langOtherValue] = {
                                    'entry': langListInfo['entry'],
                                    'id': langListInfo['id'],
                                    'index': langIndex,
                                    'lang': langOtherValue,
                                    'text': '',
                                    'type': langListInfo['type']
                                }
                            }
                        }

                        rowIndex = rowIndex + 1;
                    }

                    if (langList[rowIndex] === undefined) {
                        langList[rowIndex] = {};
                    }

                    if (hasBokmal) {
                        if (lang === 'E' || lang === 'N') {
                            lang = 'E-N';
                        }

                        if (typeof val[i].index === 'number') {
                            let subIndex = val[i].index;
                            if (langList[subIndex] === undefined) {
                                langList[subIndex] = {};
                            }
                            langList[subIndex][lang] = val[i];
                        } else if (langList[rowIndex][lang] === undefined) {
                            langList[rowIndex][lang] = val[i];
                        } else {
                            // console.log("Exclude: [Lexin: " + val[i].id + ": " + lang + "] '" + val[i].type + "' - " + val[i].sub_id + ": " + val[i].text, langList[rowIndex][lang]);
                        }
                    } else {
                        // console.log("do not have bookmal yet: "  + val[i].type + "' - " + val[i].sub_id + ": " + val[i].text);
                    }
                }
            }

            for (let index in langList) {
                let langCode = 'E-N';
                if (langList[index][langCode] !== undefined) {
                    bok.push(langList[index][langCode]);
                    if (langList[index][langCode].index !== undefined &&
                        typeof langList[index][langCode].index === 'number') {
                        bokHasIndex = true;
                    }
                }

                langCode = 'B';
                if (langList[index][langCode] !== undefined) {
                    eng.push(langList[index][langCode]);
                    if (langList[index][langCode].index !== undefined &&
                        typeof langList[index][langCode].index === 'number') {
                        engHasIndex = true;
                    }
                }

                for (let langIndex in langList[index]) {
                    if (!['E-N', 'B'].includes(langIndex)) {
                        langCode = langIndex;
                        last_lang.push(langList[index][langCode]);
                        if (langList[index][langCode].index !== undefined &&
                            typeof langList[index][langCode].index === 'number') {
                            otherHasIndex = true;
                        }
                    }
                }
            }

            if (bokHasIndex) {
                bok = this.sortDistinctValue(bok);
            }

            if (engHasIndex) {
                eng = this.sortDistinctValue(eng);
            }

            if (otherHasIndex) {
                last_lang = this.sortDistinctValue(last_lang);
            }

            for (let i = 0; i < bok.length; i++) {
                let hasContent = false;
                if (bok[i].text !== undefined && bok[i].text) {
                    hasContent = true;
                } else if (eng[i] !== undefined && eng[i].text) {
                    hasContent = true;
                } else if (last_lang[i] !== undefined && last_lang[i].text) {
                    hasContent = true;
                }

                if (hasContent) {
                    if (bok[i] !== undefined) {
                        bok[i].showHr = false;
                    }
                    if (eng[i] !== undefined) {
                        eng[i].showHr = false;
                    }
                    if (last_lang[i] !== undefined) {
                        last_lang[i].showHr = false;
                    }

                    if (bok[i].text) {
                        bok[i].showHr = true;
                    } else if (eng[i] !== undefined && eng[i].text) {
                        eng[i].showHr = true;
                    } else if (last_lang[i] !== undefined && last_lang[i].text) {
                        last_lang[i].showHr = true;
                    } else {
                        bok[i].showHr = true;
                    }

                    arr_result.push(bok[i]);
                    if (eng[i] !== undefined) {
                        arr_result.push(eng[i]);
                    }

                    if (last_lang[i] !== undefined) {
                        arr_result.push(last_lang[i]);
                    }
                }
            }

            return arr_result;
        },
        getFirstFreeRowIndex(indexMap, rowIndex) {
            for (let j=0; j<indexMap.length; j++) {
                if (indexMap[j] === undefined) {
                    return j;
                }
            }

            return rowIndex;
        },
        hasLangIndexMap(langIndexMap, lang, rowIndex) {
            let value = false;
            if (langIndexMap[lang] !== undefined &&
                langIndexMap[lang][rowIndex] !== undefined &&
                langIndexMap[lang][rowIndex] === true) {
                value = true;
            }

            return value;
        },
        getLangListInfoFromLangListRow(langUppercase, langList) {
            if (Object.keys(langList).length > 0) {
                for (let lang in langList) {
                    const info = langList[lang];
                    const langCode = this.capitalizeFirstLetter(langUppercase.toLowerCase());
                    const langInfo = {
                        'entry': info['entry'],
                        'id': info['id'],
                        'index': info['index'],
                        'lang': langUppercase,
                        'text': '',
                        'type': langCode + '-' + info['entry'].toLowerCase()
                    }

                    return langInfo;
                }
            }

            return [];
        },

        //#endregion
        getOrdbankLemValue(languageCode) {
            let value = '';

            if (languageCode == 'nob') {
                if (this.eLem != undefined) {
                    value = this.eLem.text;
                } else if (this.nLem != undefined) {
                    value = this.nLem.text;
                }
            } else if (languageCode == 'nno') {
                if (this.lastLem != undefined) {
                    value = this.lastLem.text;
                }
            }

            return value;
        },
        getSearchWord() {
            return this.searchInput.replace(/^\s+|\s+$/g, "").trim();
        },
        //#region  function to group all the records from data for particular id.
        //this method is used to format the result of dictionary into html parameters in arranged order
        mapIntoHtml() {
            var searchWord = this.searchInput.replace(/^\s+|\s+$/g, "").trim();
            var imagethemePage = false;
            if (this.searchInput == "") {
                imagethemePage = true;
            }
            var loaded = this.loaded;
            this.xres = _.map(this.xres, function (group) {
                var split = group.type.split("-");
                if (group.text.includes("||")) {
                } else if (group.text.includes("|")) {
                    group.text = group.text.split("|")[1];
                }
                return {
                    id: group.id,
                    sub_id: group.sub_id,
                    text: decode_utf8(
                        group.text,
                        split.length > 1 ? split[1].toUpperCase() : "",
                        imagethemePage,
                        loaded
                    ),
                    type: group.type,
                    index: group.index,
                    lang: split[0].toUpperCase(),
                    entry: split.length > 1 ? split[1].toUpperCase() : ""
                };
            });

            //#region function to append anchor element to the hyperlinks
            function append_hyperlink(text) {
                var res = text.match(/[\^].[^\^]*[\^]/gi);
                var result = "";
                if (res != null) {
                    for (var i = 0; i < res.length; i++) {
                        result = res[i].replace(/[/^]/g, "");
                        text = text.replace(
                            res[i],
                            "<a href='javascript:void(0)'>" + result + "</a>"
                        );
                    }
                }
                return text;
            }

            //#endregion

            //#region function to highlight the text which matches with the searchword
            function HighlightMatchedtext(text, type) {
                searchWord = searchWord.replace("|", "~");
                if (type !== "UTT" && type !== "KAT") {
                    if (!searchWord) return text;

                    // Escape regex special characters
                    const escaped = searchWord.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");

                    // Allow optional ~ after each character (except space)
                    const pattern = [...escaped]
                        .map(char =>
                            char !== " " ? `${char}(?:~*)?` : char
                        )
                        .join("");

                    // Prevent matching inside HTML tags
                    const regex = new RegExp(
                        pattern + "(?![^<>]*>)",
                        "gi"
                    );

                    return text.replace(regex, "<span class=\"highlight\">$&</span>");
                } else {
                    return text;
                }
            }

            //#endregion

            //#region function to call the hyperlink and highlight function on the basis of condition
            function decode_utf8(text, type, imagethemePage, loaded) {
                if (text.includes("^")) {
                    text = append_hyperlink(text); //for hyperlink
                }
                if (!imagethemePage && !loaded) {
                    text = HighlightMatchedtext(text, type);
                }
                //text = text.replace(/~/g, "|");
                //return text;
                text = text.replace(/~/g, "<span class='pipe-class'></span>");
                let parser = new DOMParser();
                let dom = parser.parseFromString('<!doctype html><body>' + text, 'text/html');
                if (dom.body.innerHTML.includes('&amp;')) {
                    return dom.body.innerHTML.replace(/&amp;/g, '&');
                } else {
                    return dom.body.innerHTML
                }
            }

            //#endregion

            this.filterData(this.xres);
        },
        //#endregion

        //#region  function to get the content inside the span tag.
        extractContent(s) {
            var span = document.createElement("span");
            span.innerHTML = s;
            return span.textContent || span.innerText;
        },
        //#endregion

        //#region function to redirect to the picture page when clicked on image icon
        getImage(val1, val2, val3, val4) {
            var router = this.$router.resolve({
                name: "PictureComponent",
                params: {
                    id: val1,
                    wordtext: val2,
                    wordId: val3,
                    lang: val4,
                    isScrollTop: true,
                    dictionary: this.dictionary
                }
            });
            if (router.location.params.id === this.$route.params.id &&
                router.location.params.lang === this.$route.params.lang) {
                this.$eventBus.$emit(
                    "map-image",
                    {
                        id: val1,
                        wordtext: val2,
                        wordId: val3,
                        lang: val4,
                        isScrollTop: true,
                        dictionary: this.dictionary
                    }
                );
            } else {
                this.$router.push({
                    name: "PictureComponent",
                    params: {
                        id: val1,
                        wordtext: val2,
                        wordId: val3,
                        lang: val4,
                        isScrollTop: true,
                        dictionary: this.dictionary
                    }
                });
            }

        },
        //#endregion

        //#region function to append onclick event to the hyperlinks
        addOnClickToHyperlink() {
            var _this = this;
            var links = [];
            if (this.refElements !== undefined) {
                Object.keys(this.refElements).forEach(key =>
                    addlinks(this.refElements[key])
                );
                for (var i = 0; i < links.length; i++) {
                    if (links[i].tagName === "A") {
                        links[i].addEventListener("click", function (event) {
                            _this.$eventBus.$emit(
                                "send-temp",
                                event.currentTarget.text.trim()
                            );
                            if (_this.isPicturepage) {
                                localStorage.setItem(
                                    "searchWord",
                                    event.currentTarget.text.trim()
                                );
                                _this.$router.push({
                                    name: "FindwordsComponent",
                                    params: {dictionary: _this.dictionary, isSearch: true}
                                });
                            }
                        });
                    }
                }
            }
            this.refElements = [];
            links = [];

            function addlinks(eLem) {
                if (
                    eLem !== undefined &&
                    eLem.children !== undefined &&
                    eLem.children.length !== 0
                ) {
                    var arr = eLem.children;
                    for (var j = 0; j < arr.length; j++) {
                        links.push(arr[j]);
                    }
                } else if (eLem !== undefined) {
                    if (eLem.length > 0) {
                        for (var i = 0; i < eLem.length; i++) {
                            arr = eLem[i].children;
                            for (j = 0; j < arr.length; j++) {
                                links.push(arr[j]);
                            }
                        }
                    }
                }
            }
        },
        //#endregion

        //#region function to send the sms text for picture page
        getName(val) {
            var splitText = val.split(" ")[0];
            splitText = splitText.split(";")[0];
            return splitText;
        },
        //#endregion

        getResultIndex(postFix) {
            return this.resultIndex + '-' + postFix;
        },
        hasNorskOrdbank(languageCode) {
            let value = false;
            let ordbank = false;
            if (languageCode == 'nob') {
                if (this.eLem != undefined && this.eLem) {
                    ordbank = this.getOrdbankResultByEMor(this.eLem);
                } else if (this.nLem != undefined && this.listLength(this.nLem) > 0) {
                    ordbank = this.getOrdbankResultByEMor(this.nLem);
                }
            } else if (this.lastLem != undefined && this.listLength(this.lastLem) > 0) {
                ordbank = this.getOrdbankResultByEMor(this.lastLem);
            }

            if (this.listLength(ordbank) > 0) {
                value = true;
            }

            return value;
        },
        getNorskOrdbank(languageCode) {
            let ordbank = false;
            if (languageCode == 'nob') {
                if (this.eLem != undefined && this.listLength(this.eLem) > 0) {
                    ordbank = this.getOrdbankResultByEMor(this.eLem);
                } else if (this.nLem != undefined && this.listLength(this.nLem) > 0) {
                    ordbank = this.getOrdbankResultByEMor(this.nLem);
                }
            } else if (this.lastLem != undefined && this.listLength(this.lastLem) > 0) {
                ordbank = this.getOrdbankResultByEMor(this.lastLem);
            }

            return ordbank;
        },
        showLastOrdbank() {
            let value = false;
            if (this.lastLem != undefined && this.lastLem.lang != undefined &&
                this.lastLem.lang !== '' && this.lastLem.lang !== '-') {
                value = true;
            } else if (this.lastkat != undefined && this.lastkat.lang != undefined &&
                this.lastkat.lang !== '' && this.lastkat.lang !== '-') {
                value = true;
            }

            return value;
        },
        getDefaultOrdbankOpen(eLem, nLem, lastLem) {
            // Should allways be shown closed.
            return false;

            // let value = true;
            // if (((typeof eLem == "object" && eLem.type != undefined) ||
            //     (typeof nLem == "object" && nLem.type != undefined)) &&
            //     typeof lastLem == "object" && lastLem.type != undefined) {
            //
            //     if (((eLem != undefined && eLem.type != undefined && eLem.type == 'E-lem') ||
            //          (nLem != undefined && nLem.type != undefined && nLem.type == 'N-lem')) &&
            //         (lastLem != undefined && lastLem.type != undefined && lastLem.type == 'Nny-lem')) {
            //         value = false;
            //     }
            // }
            //
            // return value;
        },
        getOrdbankInitialBlockInfo(languageCode) {
            let list = {
                'lem_info': {},
                'kat_info': {},
                'mor_info': {}
            };

            if (languageCode === 'last' || languageCode === 'nno') {
                if (typeof this.lastkat == "object" && this.lastkat.text !== undefined) {
                    list['kat_info'] = this.lastkat || {};
                }

                if (typeof this.lastLem == "object" && this.lastLem.text !== undefined) {
                    list['lem_info'] = this.lastLem || {};
                }

                if (typeof this.lastMor == "object" && this.lastMor.text !== undefined) {
                    list['mor_info'] = this.lastMor || {};
                }

                if (typeof this.lastLem == "object" && this.lastLem.text !== undefined) {
                    let langCode = this.lastLem.type.split('-')[0];
                    if (langCode === 'Nny') {
                        languageCode = 'nno';
                    }
                }
            } else if (languageCode === 'nob') {
                if (typeof this.eLem == "object" && this.eLem.text !== undefined) {
                    list['lem_info'] = this.eLem || {};
                } else if (typeof this.nLem == "object" && this.nLem.text !== undefined) {
                    list['lem_info'] = this.nLem || {};
                }

                if (typeof this.eKat == "object" && this.eKat.text !== undefined) {
                    list['kat_info'] = this.eKat || {};
                } else if (typeof this.nKat == "object" && this.nKat.text !== undefined) {
                    list['kat_info'] = this.nKat || {};
                }

                if (typeof this.eMor == "object" && this.eMor.text !== undefined) {
                    list['mor_info'] = this.eMor || {};
                } else if (typeof this.nLem == "object" && this.nLem.text !== undefined) {
                    list['mor_info'] = this.nMor || {};
                }
            }

            if (languageCode === 'nob' || languageCode === 'nno') {
                list['norsk_ordbank'] = this.getOrdbankResultByEMor(list.lem_info);
                list['result_index'] = this.getResultIndex(languageCode);
            } else {
                list['norsk_ordbank'] = {};
                list['result_index'] = {};
            }

            list['part_of_speach_info'] = this.partOfSpeachInfo || {};
            list['language_code'] = languageCode;
            list['sn_id'] = this.getSnId();

            return list;
        },
        getSnId() {
            let value = 0;
            for (let i in this.Val) {
                if (this.Val[i]['id'] !== undefined && this.Val[i]['id'] > 0) {
                    return this.Val[i]['id'];
                }
            }

            return value;
        },
        getLangAttribute(languageCode) {
            let value = '';

            if (languageCode == 'last') {
                if (typeof this.lastLem == "object" && this.lastLem.lang != undefined) {
                    value = this.languageCodeList.find(x=>x.lang==this.lastLem.lang).langISOCode;
                } else if (typeof this.bLem == "object" && this.bLem.text != undefined) {
                    value = this.bLem.langISOCode;
                }
            } else if (languageCode == 'nob') {
                value = 'no';
            } else if (languageCode == 'nno') {
                value = 'nn';
            }

            return value;
        },
        hasLanguageContent(lemInfo) {
            let value = false;

            if (typeof lemInfo == "object" && lemInfo.type != undefined) {
                value = true;
            }

            return value;
        },
        getOrdbankResultByEMor(eLem) {
            let ordbankResult = {};
            if (typeof eLem == "object" && eLem.type != undefined) {
                let id = eLem.id || 0;
                let langCode = eLem.type.split("-")[0];
                if (this.cache['ord_result'] != undefined &&
                    this.cache['ord_result'][id] != undefined &&
                    this.cache['ord_result'][id][langCode] != undefined) {
                    ordbankResult = this.cache['ord_result'][id][langCode];
                } else {
                    let isoLangCode = "";
                    if (langCode == "Nny") {
                        isoLangCode = "nno";
                    } else if (langCode == "N" || langCode == "E") {
                        isoLangCode = "nob";
                    }

                    if (typeof this.ordbankList == "object" &&
                        isoLangCode in this.ordbankList &&
                        typeof this.ordbankList[isoLangCode] == "object" &&
                        id in this.ordbankList[isoLangCode]) {
                        ordbankResult = this.ordbankList[isoLangCode][id];
                    }
                    if (this.cache['ord_result'] == undefined) {
                        this.cache['ord_result'] = {};
                        this.cache['ord_result'][id] = {};
                    } else if (this.cache['ord_result'][id] == undefined) {
                        this.cache['ord_result'][id] = {};
                    }

                    this.cache['ord_result'][id][langCode] = ordbankResult;
                }
            }

            return ordbankResult;
        },
        addClass(letter) {
            if (letter == 'y') {
                return 'underline_position';
            } else {
                return '';
            }
        },
        getRedClassIfNonNorwegian(lastLem) {
            let value = "";

            if (typeof lastLem == "object" && lastLem.type != undefined) {
                let lang = lastLem.type.split("-")[0];
                if (lang == "N" || lang == "E" || lang == "Nny") {
                    value = "red";
                }
            }

            return value;
        },
        getLanguageIsoCode() {
            let value = "";
            if (this.listLength(this.eLem)) {
                value = this.languageCodeList.find(x=>x.lang==this.eLem.lang).langISOCode
            } else if (this.listLength(this.nLem)) {
                value = this.languageCodeList.find(x=>x.lang==this.nLem.lang).langISOCode
            }

            return value;
        },
        hasTextProperty(objInfo) {
            let value = false;
            if (typeof objInfo == "object" && objInfo.text !== undefined && typeof objInfo.text == "string") {
                value = true;
            }

            return value;
        },
        listLength(list) {
                let value = 0;

            if (typeof list == "object" && Object.keys(list).length > 0) {
                value = Object.keys(list).length;
            }

            return value;
        }
        //#endregion
    }
};
</script>
<style>
</style>
